import type BaseEnumType from "@/app/services/baseEnumType";

export interface BmConfirmationDialogOptions {
  type: EnumDialogType;
  width: number;
  customConfirmButtonText: string;
  customCancelButtonText: string;
  closeable: boolean;
  isBodyHtml: boolean;
  large: boolean;
}
export interface BmConfirmationDialogInterface {
  open(
    title: string,
    message: string,
    options?: Partial<BmConfirmationDialogOptions>
  ): Promise<boolean>;
}

export interface BmInformationDialogOptions {
  type: EnumDialogType;
  width: number;
  customCloseButtonText: string;
  large: boolean;
  preserveWhitespace: boolean;
  isBodyHtml: boolean;
}

export interface BmInformationDialogInterface {
  open(
    title: string,
    message: string,
    options?: Partial<BmInformationDialogOptions>
  ): Promise<void>;
}

// Enum handling different Dialog status, and their classes/colours.
export class EnumDialogType implements BaseEnumType {
  private static allValues: EnumDialogType[] = []; // make sure this is top-most

  public static none = new EnumDialogType(0, "None", "", "primary");
  public static error = new EnumDialogType(
    1,
    "Error",
    "bm-card-error",
    "primary-danger"
  );
  public static warning = new EnumDialogType(
    2,
    "Warning",
    "bm-card-warning",
    "primary"
  );
  public static success = new EnumDialogType(
    3,
    "Success",
    "bm-card-success",
    "primary"
  );
  public static info = new EnumDialogType(4, "Info", "bm-card-info", "primary");

  public key: number;
  public value: string;
  public dialogClass: string;
  public confirmButtonClass: string;

  private constructor(
    key: number,
    value: string,
    dialogClass: string,
    confirmButtonClass: string
  ) {
    this.key = key;
    this.value = value;
    this.dialogClass = dialogClass;
    this.confirmButtonClass = confirmButtonClass;
    EnumDialogType.allValues.push(this);
  }

  public static getValues(): EnumDialogType[] {
    return EnumDialogType.allValues;
  }

  public static getByKey(key: number): EnumDialogType {
    const found = EnumDialogType.allValues.find((e) => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumDialogType - Key not found: ${key}`);
    }

    return found;
  }
}
